export default __webpack_public_path__ + "static/media/Complete.a2d9aea7.svg";